import ApplicationState from "@/state/ApplicationState"
import SessionState from "@/state/SessionState"
import FieldState from "@/state/FieldState"
import ProviderState from "@/state/ProviderState"
import ValidationState from "@/state/ValidationState"
import LearnHowState from "@/state/LearnHowState";

export const applicationState = ApplicationState
export const fieldState = FieldState
export const providerState = ProviderState
export const learnHowState = LearnHowState
export const sessionState = SessionState
export const validationState = ValidationState

export class applyState {}
